const passwordValidator = (value: string) => {
  const result = []
  if (value === '') {
    result.push('Wachtwoord is vereist')
  } else if (value.length < 8) {
    result.push('Vul minimaal 8 tekens in')
  }
  return result
}

export default passwordValidator
